<div class="cs-lap">
  <div *ngIf="toltodik">Betöltés…</div>
  <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

  <ng-container *ngIf="adat">
    <!-- ── ÁLLAPOT ─────────────────────────────────────────────── -->
    <ion-card class="cs-allapot" [class.cs-ki]="!b.bekapcsolva || szunetel">
      <ion-card-header>
        <ion-card-title>
          <ion-icon name="notifications-outline"></ion-icon>
          Iskolai csengő —
          <span *ngIf="b.bekapcsolva && !szunetel" class="cs-be">BEKAPCSOLVA</span>
          <span *ngIf="b.bekapcsolva && szunetel" class="cs-szunet">SZÜNETEL {{ b.szunet_eddig | slice:0:16 }}-ig</span>
          <span *ngIf="!b.bekapcsolva" class="cs-kikapcs">KIKAPCSOLVA</span>
        </ion-card-title>
        <ion-card-subtitle>
          A csengő-gép a Sulinformból kéri le a napi tervet a csengetési rend és a tanév rendje szerint;
          a változást fél percen belül követi.
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="cs-sor">
          <ion-toggle [checked]="b.bekapcsolva" [disabled]="mentes" (ionChange)="kapcsol($event.detail.checked)">
            Csengő bekapcsolva
          </ion-toggle>
        </div>

        <div class="cs-sor">
          <label class="cs-mezo">Szünetel eddig
            <input type="datetime-local" [(ngModel)]="szunetEddig">
          </label>
          <ion-button size="small" fill="outline" (click)="szunetMent()" [disabled]="mentes">
            <ion-icon slot="start" name="pause-outline"></ion-icon>Szüneteltetés
          </ion-button>
          <ion-button size="small" fill="clear" *ngIf="b.szunet_eddig" (click)="szunetTorol()" [disabled]="mentes">
            Szüneteltetés megszüntetése
          </ion-button>
        </div>

        <div class="cs-racs">
          <div>
            <small>Csengő-gép</small>
            <b *ngIf="!aktivEszkozok.length">nincs felvéve</b>
            <div *ngFor="let e of aktivEszkozok">
              <span class="cs-pont" [class.cs-online]="e.online"></span>
              <b>{{ e.nev }}</b> — {{ e.online ? 'online' : 'offline' }}
              <small>(utoljára {{ mpOta(e.mp_ota) }}<span *ngIf="e.utolso_allapot?.offline">, gyorsítótárból csenget</span>)</small>
              <div class="cs-hiba" *ngIf="e.utolso_allapot?.hiba">⚠ {{ e.utolso_allapot.hiba }}</div>
              <div class="halvany" *ngIf="e.utolso_allapot?.fut === false">A gépen az ütemező le van állítva.</div>
            </div>
          </div>
          <div>
            <small>Következő csengetés</small>
            <b>{{ kovetkezo }}</b>
          </div>
          <div>
            <small>Utolsó csengetés (a gép jelentése)</small>
            <b *ngIf="utolsoCsenges">{{ utolsoCsenges.idopont }} — {{ utolsoCsenges.reszlet || esemenyNev(utolsoCsenges.esemeny) }}</b>
            <b *ngIf="!utolsoCsenges">még nincs</b>
          </div>
        </div>

        <div class="cs-sor cs-gombok">
          <ion-button color="warning" (click)="parancs('csenges_most')">
            <ion-icon slot="start" name="notifications"></ion-icon>Csengess most
          </ion-button>
          <ion-button fill="outline" (click)="parancs('teszt')">
            <ion-icon slot="start" name="volume-medium-outline"></ion-icon>Teszt
          </ion-button>
          <ion-button color="danger" (click)="parancs('leallitas')">
            <ion-icon slot="start" name="stop-circle-outline"></ion-icon>Azonnali leállítás
          </ion-button>
        </div>
        <small class="halvany">
          Az „Azonnali leállítás" az épp szóló csengetést hallgattatja el; a további csengetéseket a fenti kapcsoló
          vagy a szüneteltetés állítja meg.
        </small>
      </ion-card-content>
    </ion-card>

    <!-- ── KÖVETKEZŐ NAPOK ─────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>A következő napok csengetései</ion-card-title>
        <ion-card-subtitle>Így kapja a gép. Ha egy napon nincs csengetés, mellette az oka.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="cs-jelmagyarazat" *ngIf="b.jelzo_perc > 0">
          <span class="cs-ido cs-jelzo"><ion-icon name="alarm-outline"></ion-icon>07:45</span>
          = jelzőcsengő ({{ b.jelzo_perc }} perccel a becsengetés előtt, {{ b.jelzo_mp }} mp, a rendestől eltérő hanggal)
        </div>
        <div class="cs-tabla-wrap">
          <table class="cs-tabla">
            <tbody>
              <tr *ngFor="let n of adat.terv" [class.halvany]="!n.csengetesek.length">
                <td class="cs-nap"><b>{{ n.datum }}</b><br><small>{{ n.het_napja }}</small></td>
                <td>
                  <span *ngIf="n.indok" class="cs-indok" [class.cs-elteres]="n.forras === 'elteres'">{{ n.indok }}</span>
                  <div class="cs-idok" *ngIf="n.csengetesek.length">
                    <span *ngFor="let c of n.csengetesek" class="cs-ido" [class.cs-jelzo]="c.fajta === 'jelzo'"
                          [title]="csengetesCim(c)"><ion-icon *ngIf="c.fajta === 'jelzo'" name="alarm-outline"></ion-icon>{{ c.time }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- ── CSENGETÉSI REND ─────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Csengetési rend</ion-card-title>
        <ion-card-subtitle>
          A {{ adat.csengetesi_rend.ev }}/{{ adat.csengetesi_rend.ev + 1 }}. tanév rendje a Sulinformból.
          Itt csak az dönthető el, melyik óra kezdete és vége szóljon, és melyik előtt szóljon jelzőcsengő. Maguk az időpontok az aSc-órarend
          importjával (Admin → Import → aSc XML) kerülnek be, és tanévváltáskor másolódnak.
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-note color="warning" *ngIf="adat.csengetesi_rend.ev && adat.csengetesi_rend.ev !== adat.csengetesi_rend.aktualis_ev">
          Az aktuális tanévre még nincs csengetési rend – addig a {{ adat.csengetesi_rend.ev }}/{{ adat.csengetesi_rend.ev + 1 }}. tanévé szól.
        </ion-note>
        <ion-note color="danger" *ngIf="!adat.csengetesi_rend.orak.length">
          Nincs felvéve csengetési rend – a gép így nem kap csengetést.
        </ion-note>
        <table class="cs-tabla" *ngIf="adat.csengetesi_rend.orak.length">
          <thead>
            <tr>
              <th>Óra</th><th>Kezdés</th><th>Vége</th><th>Kezdéskor szól</th><th>A végén szól</th>
              <th [class.halvany]="!(b.jelzo_perc > 0)" title="A becsengetés előtt a Beállításokban megadott perccel">Jelzőcsengő előtte</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of adat.csengetesi_rend.orak">
              <td>{{ o.oraszam }}.</td>
              <td>{{ o.kezdes }}</td>
              <td>{{ o.vege }}</td>
              <td><ion-checkbox [checked]="o.kezdes" (ionChange)="o.kezdes = $event.detail.checked; orakModosult = true"></ion-checkbox></td>
              <td><ion-checkbox [checked]="o.vege" (ionChange)="o.vege = $event.detail.checked; orakModosult = true"></ion-checkbox></td>
              <td><ion-checkbox [checked]="o.jelzo" (ionChange)="o.jelzo = $event.detail.checked; orakModosult = true"></ion-checkbox></td>
            </tr>
          </tbody>
        </table>
        <small class="halvany" *ngIf="!(b.jelzo_perc > 0)">
          A jelzőcsengő most ki van kapcsolva – a Beállításoknál adható meg, hány perccel a becsengetés előtt szóljon.
        </small>
        <ion-button size="small" color="success" *ngIf="orakModosult" (click)="orakMent()" [disabled]="mentes">
          <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
        </ion-button>
      </ion-card-content>
    </ion-card>

    <!-- ── NAP-ELTÉRÉSEK ───────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Eltérő napok</ion-card-title>
        <ion-card-subtitle>
          Egy-egy nap, amikor nem a szokásos rend szól: csend (pl. tanítás nélküli munkanap), vagy rövidített nap
          saját időpontokkal. Az eltérés mindent felülír, a szünetet és a hétvégét is.
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-button size="small" fill="outline" (click)="elteresUj()" *ngIf="!elteresNyitva">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>Új eltérés
        </ion-button>

        <div class="cs-urlap" *ngIf="elteresNyitva">
          <div class="cs-sor">
            <label class="cs-mezo">Nap<input type="date" [(ngModel)]="elteres.datum"></label>
            <label class="cs-mezo">Mi legyen aznap
              <select [(ngModel)]="elteres.tipus">
                <option value="nincs">Nincs csengetés</option>
                <option value="egyedi">Egyedi időpontok (pl. rövidített nap)</option>
              </select>
            </label>
            <label class="cs-mezo cs-szeles">Megjegyzés
              <input type="text" [(ngModel)]="elteres.megjegyzes" maxlength="255" placeholder="pl. rövidített órák – tanévnyitó">
            </label>
          </div>
          <div *ngIf="elteres.tipus === 'egyedi'">
            <ion-button size="small" fill="clear" (click)="elteresRendbol()">A szokásos rend betöltése kiindulásnak</ion-button>
            <small class="halvany" *ngIf="b.jelzo_perc > 0">
              A jelzőcsengő az „N. óra kezdés” címkéjű időpontok előtt magától szól – külön felvenni nem kell.
            </small>
            <div class="cs-sor" *ngFor="let x of elteres.idopontok; let i = index">
              <input type="time" [(ngModel)]="x.time">
              <input type="text" [(ngModel)]="x.label" placeholder="pl. 1. óra kezdés" maxlength="80">
              <ion-button size="small" fill="clear" color="danger" (click)="idopontTorol(i)">
                <ion-icon name="trash-outline"></ion-icon>
              </ion-button>
            </div>
            <ion-button size="small" fill="clear" (click)="idopontHozzaad()">
              <ion-icon slot="start" name="add-outline"></ion-icon>Időpont
            </ion-button>
          </div>
          <div class="cs-sor">
            <ion-button size="small" color="success" (click)="elteresMent()">
              <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
            </ion-button>
            <ion-button size="small" fill="clear" (click)="elteresNyitva = false">Mégse</ion-button>
          </div>
        </div>

        <table class="cs-tabla" *ngIf="adat.elteresek.length">
          <thead><tr><th>Nap</th><th>Mi szól</th><th>Megjegyzés</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let e of adat.elteresek">
              <td>{{ e.datum }}</td>
              <td>
                <span *ngIf="e.tipus === 'nincs'">nincs csengetés</span>
                <span *ngIf="e.tipus === 'egyedi'">
                  <span *ngFor="let x of e.idopontok" class="cs-ido" [title]="x.label">{{ x.time }}</span>
                </span>
              </td>
              <td>{{ e.megjegyzes }}</td>
              <td class="muvelet">
                <ion-button size="small" fill="clear" (click)="elteresSzerkeszt(e)"><ion-icon name="create-outline"></ion-icon></ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="elteresTorol(e)"><ion-icon name="trash-outline"></ion-icon></ion-button>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="halvany" *ngIf="!adat.elteresek.length && !elteresNyitva">Nincs felvett eltérés.</p>
      </ion-card-content>
    </ion-card>

    <!-- ── BEÁLLÍTÁSOK ─────────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Beállítások</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="cs-sor">
          <label class="cs-mezo">Csengés hossza (mp)
            <input type="number" min="1" max="60" [(ngModel)]="adat.beallitas.csenges_mp">
          </label>
          <label class="cs-mezo">Hangerő (0 – 1)
            <input type="number" min="0" max="1" step="0.05" [(ngModel)]="adat.beallitas.hangero">
          </label>
        </div>
        <div class="cs-sor">
          <label class="cs-mezo">Jelzőcsengő a becsengetés előtt (perc, 0 = nincs)
            <input type="number" min="0" max="15" step="1" [(ngModel)]="adat.beallitas.jelzo_perc">
          </label>
          <label class="cs-mezo">Jelzőcsengő hossza (mp)
            <input type="number" min="1" max="30" step="1" [(ngModel)]="adat.beallitas.jelzo_mp" [disabled]="!(adat.beallitas.jelzo_perc > 0)">
          </label>
        </div>
        <small class="halvany">
          A jelzőcsengő az „N. óra kezdés” előtt szól, a rendes csengőtől eltérő hanggal (a hangot a csengő-gépen
          lehet kiválasztani). Ugyanott szól, ahol a rendes csengő: hétvégén, szünetben nem; rövidített (egyedi) napon az
          ott felvett óra-kezdések előtt. Ha ugyanarra a percre már szól egy csengetés, a jelző elmarad.
          Óránként a Csengetési rendnél kapcsolható ki.
        </small>
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="b.hetvege_nem" (ionChange)="adat.beallitas.hetvege_nem = $event.detail.checked"></ion-checkbox>
          <ion-label>Hétvégén nincs csengetés (az áthelyezett munkanapon igen)</ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="b.tanev_rendje_szerint" (ionChange)="adat.beallitas.tanev_rendje_szerint = $event.detail.checked"></ion-checkbox>
          <ion-label>A tanév rendje szerint (szünetben, tanítás nélküli munkanapon nincs csengetés)</ion-label>
        </ion-item>
        <small class="halvany">A törvényes munkaszüneti napokon (pl. május 1., pünkösdhétfő) mindig csend van.</small>
        <div class="cs-sor">
          <ion-button size="small" color="success" (click)="altalanosMent()" [disabled]="mentes">
            <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- ── ESZKÖZÖK ────────────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Csengő-gépek</ion-card-title>
        <ion-card-subtitle>
          A gép egy kulccsal azonosítja magát. A kulcsot csak felvételkor mutatjuk meg – ezt kell beírni a
          csengő-programba (Sulinform-kulcs).
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="cs-sor">
          <label class="cs-mezo">Új gép neve<input type="text" [(ngModel)]="ujEszkozNev" maxlength="100"></label>
          <ion-button size="small" fill="outline" (click)="eszkozFelvesz()">
            <ion-icon slot="start" name="key-outline"></ion-icon>Kulcs kiadása
          </ion-button>
        </div>

        <div class="cs-kulcs" *ngIf="ujKulcs">
          <b>{{ ujKulcs.nev }} – a kulcs (csak most látható!):</b>
          <code>{{ ujKulcs.kulcs }}</code>
          <div class="cs-sor">
            <ion-button size="small" (click)="kulcsMasol()"><ion-icon slot="start" name="copy-outline"></ion-icon>Másolás</ion-button>
            <ion-button size="small" fill="clear" (click)="ujKulcs = null">Kész, bemásoltam</ion-button>
          </div>
        </div>

        <table class="cs-tabla" *ngIf="adat.eszkozok.length">
          <thead><tr><th>Név</th><th>Állapot</th><th>Program</th><th>Kiadva</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let e of adat.eszkozok" [class.halvany]="!e.aktiv">
              <td><span class="cs-pont" [class.cs-online]="e.online"></span>{{ e.nev }}</td>
              <td>
                <span *ngIf="!e.aktiv">visszavonva {{ e.visszavonva }}</span>
                <span *ngIf="e.aktiv">{{ e.online ? 'online' : 'offline' }} · {{ mpOta(e.mp_ota) }}</span>
                <div *ngIf="e.aktiv && e.utolso_allapot?.ora_elteres_mp && (e.utolso_allapot.ora_elteres_mp > 30 || e.utolso_allapot.ora_elteres_mp < -30)" class="cs-hiba">
                  A gép órája {{ e.utolso_allapot.ora_elteres_mp }} mp-cel eltér a kiszolgálóétól.
                </div>
              </td>
              <td><small>{{ e.utolso_allapot?.verzio }} {{ e.utolso_allapot?.mod }}</small></td>
              <td><small>{{ e.letrehozva }} {{ e.letrehozta }}</small></td>
              <td class="muvelet">
                <ion-button size="small" fill="clear" color="danger" *ngIf="e.aktiv" (click)="visszavon(e)">Visszavonás</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </ion-card-content>
    </ion-card>

    <!-- ── NAPLÓ ───────────────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Napló</ion-card-title>
        <ion-card-subtitle>Amit a gép jelentett (csengetés, kihagyás, hiba), és a kiküldött parancsok.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="cs-ket-oszlop">
          <div class="cs-tabla-wrap">
            <table class="cs-tabla">
              <thead><tr><th>Időpont</th><th>Esemény</th><th>Részlet</th><th>Gép</th></tr></thead>
              <tbody>
                <tr *ngFor="let n of adat.naplo">
                  <td>{{ n.idopont }}</td>
                  <td [class.cs-hiba]="n.esemeny === 'hiba'">{{ esemenyNev(n.esemeny) }}</td>
                  <td>{{ n.reszlet }}</td>
                  <td><small>{{ n.eszkoz_nev }}</small></td>
                </tr>
              </tbody>
            </table>
            <p class="halvany" *ngIf="!adat.naplo.length">Még nincs bejegyzés.</p>
          </div>
          <div class="cs-tabla-wrap" *ngIf="adat.parancsok.length">
            <table class="cs-tabla">
              <thead><tr><th>Parancs</th><th>Küldve</th><th>Átvette</th><th>Eredmény</th></tr></thead>
              <tbody>
                <tr *ngFor="let p of adat.parancsok">
                  <td>{{ parancsNev(p.parancs) }}<br><small>{{ p.letrehozta }}</small></td>
                  <td>{{ p.letrehozva }}</td>
                  <td>{{ p.atvette || 'vár…' }}<br><small>{{ p.eszkoz_nev }}</small></td>
                  <td>{{ p.eredmeny }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>
</div>
